"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Filter = require("./partials/Filter");
var _DropList = require("./partials/DropList");
var _Footer = require("./partials/Footer");
var _Select = require("./Select.styles");
var _Select2 = require("./Select.labels");
var _hooks = require("../../hooks");
var _OffsetBox = require("../../Layout/OffsetBox");
var _useOffsetBox2 = require("../../Layout/OffsetBox/useOffsetBox");
var _Button = require("../Button");
var _Icon = require("../Icon");
var _strings = require("../../utilities/strings");
var _OffsetBoxDropCard = require("../partials/OffsetBoxDropCard");
var _Header = require("./partials/Header");
var _Card = require("../Card");
var _Portal = require("../../Layout/Portal");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var emptyArray = [];
var Select = /*#__PURE__*/_react.default.forwardRef(function (props, outerRef) {
  var _btnProps$customStyle;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    themeColors = _useContext.themeColors;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var getLabel = (0, _hooks.useLabels)({
    labels: _Select2.labels
  });
  var id = props.id,
    btnProps = props.btnProps,
    _props$anchorWidth = props.anchorWidth,
    anchorWidth = _props$anchorWidth === void 0 ? 'fit-content' : _props$anchorWidth,
    _props$isMultiSelect = props.isMultiSelect,
    isMultiSelect = _props$isMultiSelect === void 0 ? false : _props$isMultiSelect,
    _props$isFullScreen = props.isFullScreen,
    isFullScreen = _props$isFullScreen === void 0 ? false : _props$isFullScreen,
    _props$btnLabel = props.btnLabel,
    btnLabel = _props$btnLabel === void 0 ? '' : _props$btnLabel,
    _props$options = props.options,
    options = _props$options === void 0 ? [] : _props$options,
    additionalOptions = props.additionalOptions,
    _props$optionSize = props.optionSize,
    optionSize = _props$optionSize === void 0 ? 'small' : _props$optionSize,
    _props$position = props.position,
    position = _props$position === void 0 ? 'bottom' : _props$position,
    _props$isAttachedToWi = props.isAttachedToWindow,
    isAttachedToWindow = _props$isAttachedToWi === void 0 ? isMobileView : _props$isAttachedToWi,
    isWithFilter = props.isWithFilter,
    _props$isWithArrow = props.isWithArrow,
    isWithArrow = _props$isWithArrow === void 0 ? true : _props$isWithArrow,
    _props$filterPlacehol = props.filterPlaceholder,
    filterPlaceholder = _props$filterPlacehol === void 0 ? '' : _props$filterPlacehol,
    additionalOptionsBtnLabel = props.additionalOptionsBtnLabel,
    isOpenOnFocus = props.isOpenOnFocus,
    _props$isBoxCenteredT = props.isBoxCenteredToAnchor,
    isBoxCenteredToAnchor = _props$isBoxCenteredT === void 0 ? false : _props$isBoxCenteredT,
    _props$isFocusFilterO = props.isFocusFilterOnOpen,
    isFocusFilterOnOpen = _props$isFocusFilterO === void 0 ? false : _props$isFocusFilterO,
    _props$isSelectOnBlur = props.isSelectOnBlur,
    isSelectOnBlur = _props$isSelectOnBlur === void 0 ? false : _props$isSelectOnBlur,
    onClose = props.onClose,
    onBlur = props.onBlur;
  var _ref = props,
    onChangeValue = _ref.onChange,
    value = _ref.value,
    isFixedBtnLabel = _ref.isFixedBtnLabel;
  var _ref2 = props,
    _ref2$values = _ref2.values,
    values = _ref2$values === void 0 ? emptyArray : _ref2$values,
    onSecondaryBtnClick = _ref2.onSecondaryBtnClick,
    onChangeValues = _ref2.onChange,
    _ref2$secondaryBtnLab = _ref2.secondaryBtnLabel,
    secondaryBtnLabel = _ref2$secondaryBtnLab === void 0 ? getLabel('clear') : _ref2$secondaryBtnLab,
    _ref2$showSelection = _ref2.showSelection,
    showSelection = _ref2$showSelection === void 0 ? false : _ref2$showSelection,
    maxSelectedOptions = _ref2.maxSelectedOptions;
  var _useState = (0, _react.useState)(position),
    _useState2 = _slicedToArray(_useState, 2),
    actualBoxPosition = _useState2[0],
    setActualBoxPosition = _useState2[1];
  var _useState3 = (0, _react.useState)(values),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedOptions = _useState4[0],
    setSelectedOptions = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = _slicedToArray(_useState5, 2),
    optionsFilterText = _useState6[0],
    setOptionsFilterText = _useState6[1];
  var _useState7 = (0, _react.useState)(options),
    _useState8 = _slicedToArray(_useState7, 2),
    FilteredOptions = _useState8[0],
    setFilteredOptions = _useState8[1];
  var _useState9 = (0, _react.useState)(additionalOptions),
    _useState10 = _slicedToArray(_useState9, 2),
    FilteredAdditionalOptions = _useState10[0],
    setFilteredAdditionalOptions = _useState10[1];
  var closeRef = (0, _react.useRef)();
  var handleCancelAndClose = (0, _react.useCallback)(function () {
    if (!isSelectOnBlur) {
      setSelectedOptions(values);
    }
    if (onClose) {
      onClose();
    }
  }, [values, onClose, isSelectOnBlur]);
  var handleListBlur = (0, _react.useCallback)(function (event) {
    if (onBlur) {
      onBlur(event, selectedOptions);
    }
    if (isSelectOnBlur && onChangeValues) {
      onChangeValues(selectedOptions);
      (closeRef === null || closeRef === void 0 ? void 0 : closeRef.current) && closeRef.current();
    }
  }, [onBlur, selectedOptions, isSelectOnBlur, onChangeValues]);
  var _useOffsetBox = (0, _useOffsetBox2.useOffsetBox)(isOpenOnFocus, handleCancelAndClose, handleListBlur, isSelectOnBlur),
    anchorRef = _useOffsetBox.anchorRef,
    dropContentRef = _useOffsetBox.dropContentRef,
    handleAnchorFocus = _useOffsetBox.handleAnchorFocus,
    handleAnchorKeyUp = _useOffsetBox.handleAnchorKeyUp,
    isOpen = _useOffsetBox.isOpen,
    toggle = _useOffsetBox.toggle,
    close = _useOffsetBox.close;
  closeRef.current = close;
  var styles = (0, _Select.useStyles)(props, isOpen);
  var arrowSize = (btnProps === null || btnProps === void 0 ? void 0 : btnProps.size) === 'large' ? 22 : (btnProps === null || btnProps === void 0 ? void 0 : btnProps.size) === 'small' ? 14 : 18;
  var getSelectBtnLabel = function getSelectBtnLabel() {
    if (isMultiSelect) {
      var label = btnLabel;
      var selectedCount = selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length;
      if (showSelection && selectedCount > 0) {
        var rest = selectedCount > 1 ? "(".concat(selectedCount - 1, "+)") : '';
        label += " ".concat(selectedOptions[0].label, " ").concat(rest);
      } else {
        label += selectedCount > 0 ? ' (' + selectedCount + ')' : '';
      }
      return label;
    } else if (value) {
      return btnLabel && isFixedBtnLabel ? btnLabel : value.label;
    } else {
      return btnLabel;
    }
  };
  var handleBoxPositionChange = function handleBoxPositionChange(pos) {
    setActualBoxPosition(pos);
  };
  var handleSelectOption = (0, _react.useCallback)(function (option) {
    if (onChangeValue) {
      onChangeValue(option);
      anchorRef.current && anchorRef.current.focus();
    }
    close();
  }, [onChangeValue, close, anchorRef]);
  var handleUpdateSelectedOptions = (0, _react.useCallback)(function (option) {
    if (isMultiSelect && selectedOptions.length > 0) {
      if (selectedOptions && selectedOptions.find(function (op) {
        return op.value === option.value;
      })) {
        // remove option
        setSelectedOptions(selectedOptions.filter(function (op) {
          return op.value !== option.value;
        }));
      } else {
        // add option
        var newSelectedOptions = [].concat(_toConsumableArray(selectedOptions), [option]);
        var sortedSelectedOptions = options.filter(function (op) {
          return newSelectedOptions.map(function (item) {
            return item.value;
          }).includes(op.value);
        }); // sort selected options by original options order
        var sortedSelectedAdditionalOptions = additionalOptions ? additionalOptions.filter(function (op) {
          return newSelectedOptions.map(function (item) {
            return item.value;
          }).includes(op.value);
        }) : []; // sort selected additional options by original options order
        setSelectedOptions(sortedSelectedOptions.concat(sortedSelectedAdditionalOptions));
      }
    } else {
      setSelectedOptions([option]);
    }
  }, [isMultiSelect, selectedOptions, options, additionalOptions]);
  var handleClose = (0, _react.useCallback)(function () {
    handleCancelAndClose();
    close();
  }, [close, handleCancelAndClose]);
  var handleSecondaryBtnClick = (0, _react.useCallback)(function () {
    if (onSecondaryBtnClick) {
      onSecondaryBtnClick();
      anchorRef.current && anchorRef.current.focus();
    }
    close();
  }, [close, onSecondaryBtnClick, anchorRef]);
  var handleSaveSelectedOptions = (0, _react.useCallback)(function () {
    if (onChangeValues) {
      onChangeValues(selectedOptions);
      anchorRef.current && anchorRef.current.focus();
    }
    close();
  }, [close, onChangeValues, selectedOptions, anchorRef]);
  var filterOptionsBy = (0, _react.useCallback)(function (options, prop, value) {
    var isWithFullPrecision = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    return (options === null || options === void 0 ? void 0 : options.filter(function (option) {
      return option.isSeparator || (isWithFullPrecision ? option[prop].toString() === (value === null || value === void 0 ? void 0 : value.toString()) : /*#__PURE__*/_react.default.isValidElement(option[prop]) ? (0, _strings.clearHtmlTags)(option[prop].props.children).includes(value === null || value === void 0 ? void 0 : value.toString()) : option[prop].toString().includes(value === null || value === void 0 ? void 0 : value.toString()));
    })) || [];
  }, []);
  var updateFilteredOptions = (0, _react.useCallback)(function (options, value) {
    if (value) {
      setFilteredOptions(filterOptionsBy(options, 'label', value));
    } else {
      setFilteredOptions(options);
    }
  }, [filterOptionsBy]);
  var updateFilteredAdditionalOptions = (0, _react.useCallback)(function (additionalOptions, value) {
    if (value) {
      setFilteredAdditionalOptions(filterOptionsBy(additionalOptions, 'label', value));
    } else {
      setFilteredAdditionalOptions(additionalOptions);
    }
  }, [filterOptionsBy]);
  var handleAnimationComplete = function handleAnimationComplete() {
    if (!isMultiSelect && (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) === 1 && dropContentRef !== null && dropContentRef !== void 0 && dropContentRef.current) {
      var _dropContentRef$curre;
      var scrollContainer = (_dropContentRef$curre = dropContentRef.current) !== null && _dropContentRef$curre !== void 0 ? _dropContentRef$curre : document;
      var selectedItem = scrollContainer.querySelector('[data-value="' + selectedOptions[0].value + '"]');
      if (selectedItem) {
        selectedItem.scrollIntoView({
          block: 'center'
        });
      }
    }
  };
  var handleUpdateOptionsFilterText = function handleUpdateOptionsFilterText(value) {
    setOptionsFilterText(value);
  };
  (0, _react.useEffect)(function () {
    updateFilteredOptions(options, optionsFilterText);
    if (additionalOptions) {
      updateFilteredAdditionalOptions(additionalOptions, optionsFilterText);
    }
  }, [options, additionalOptions, optionsFilterText, updateFilteredOptions, updateFilteredAdditionalOptions]);
  (0, _react.useEffect)(function () {
    if (outerRef) {
      outerRef.current = anchorRef.current; //todo: fix type
    }
  }, [anchorRef, outerRef]);
  (0, _react.useEffect)(function () {
    if (isMultiSelect && values) {
      setSelectedOptions(values);
    }
  }, [values, isMultiSelect]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [isAttachedToWindow && isOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Portal.Portal, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-Select-mask']
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-Select'],
      "data-testid": id ? "select-".concat(id) : null,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_OffsetBox.OffsetBox, {
        isAttachedToWindow: isAttachedToWindow,
        position: position,
        isOpen: isOpen,
        isCenteredToAnchor: isBoxCenteredToAnchor,
        onBoxPositionChange: handleBoxPositionChange,
        anchorWidth: anchorWidth,
        anchor: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, _objectSpread(_objectSpread({
          ref: anchorRef
        }, btnProps), {}, {
          onClick: toggle,
          onFocus: handleAnchorFocus,
          onKeyUp: handleAnchorKeyUp,
          role: "button",
          ariaHaspopup: "listbox",
          ariaExpanded: isOpen,
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: styles['cc-Select__btn'],
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: styles['cc-Select__btn__label'],
              children: getSelectBtnLabel()
            }), isWithArrow && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: styles['cc-Select__btn__arrow'],
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                name: "Caret",
                width: arrowSize,
                height: arrowSize,
                fillColor: (btnProps === null || btnProps === void 0 ? void 0 : btnProps.color) === 'basic' && ((btnProps === null || btnProps === void 0 ? void 0 : btnProps.view) === 'outlined' || (btnProps === null || btnProps === void 0 ? void 0 : btnProps.view) === 'text') ? themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main : 'currentColor'
              })
            })]
          })
        })),
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_OffsetBoxDropCard.OffsetBoxDropCard, {
          id: id ? "select-".concat(id) : undefined,
          ref: dropContentRef,
          position: actualBoxPosition,
          onAnimationComplete: handleAnimationComplete,
          isWithFilter: isWithFilter,
          isAttachedToWindow: isAttachedToWindow,
          isFullScreen: isFullScreen,
          width: btnProps === null || btnProps === void 0 ? void 0 : (_btnProps$customStyle = btnProps.customStyle) === null || _btnProps$customStyle === void 0 ? void 0 : _btnProps$customStyle.width,
          onClose: handleClose,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Card.Card.Section, {
            size: "small",
            flexValues: {
              flexGrow: 1
            },
            children: [isMobileView && isMultiSelect && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.Header, {
              label: getSelectBtnLabel(),
              isOptionsSelected: Boolean(selectedOptions.length),
              secondaryBtnLabel: secondaryBtnLabel,
              onSecondaryBtnClick: handleSecondaryBtnClick
            }), isWithFilter && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Filter.Filter, {
              value: optionsFilterText,
              onUpdateValue: handleUpdateOptionsFilterText,
              placeholder: filterPlaceholder,
              isFullScreen: isFullScreen,
              isFocused: isFocusFilterOnOpen
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropList.DropList, {
              options: isMultiSelect ? FilteredOptions.map(function (option) {
                return _objectSpread(_objectSpread({}, option), {}, {
                  isDisabled: maxSelectedOptions ? selectedOptions.length >= maxSelectedOptions && !selectedOptions.find(function (op) {
                    return op.value === option.value;
                  }) : false
                });
              }) : FilteredOptions,
              additionalOptions: FilteredAdditionalOptions,
              selectedOptions: isMultiSelect ? selectedOptions : value ? [value] : [],
              onSelectOption: isMultiSelect ? handleUpdateSelectedOptions : handleSelectOption,
              isMultiSelect: isMultiSelect,
              isFullScreen: isFullScreen,
              isWithFilter: isWithFilter,
              optionSize: optionSize,
              additionalOptionsBtnLabel: additionalOptionsBtnLabel !== null && additionalOptionsBtnLabel !== void 0 && additionalOptionsBtnLabel.length ? additionalOptionsBtnLabel : getLabel('showAdditionalOptions'),
              id: btnProps !== null && btnProps !== void 0 && btnProps.label ? "".concat(btnProps === null || btnProps === void 0 ? void 0 : btnProps.label, "-select") : undefined
            })]
          }), isMultiSelect && !isSelectOnBlur && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Footer.Footer, {
            onSaveSelectedOptions: handleSaveSelectedOptions,
            onClearSelectedOptions: handleSecondaryBtnClick,
            isOptionsSelected: Boolean(selectedOptions.length)
          })]
        })
      })
    })]
  });
});
exports.Select = Select;